module.exports = __webpack_public_path__ + "img/ccb_fixed_logo.2df32e54.png";